import axios from "axios";
import { devApiUrl } from "../../config";

const baseUrl = devApiUrl;

// Define the async function
export const authenticate = async (url, token, SPOrgName, PCName) => {
  //launch first script
  try {
    const fullUrl = `${baseUrl}/BCChecker`;
    const response = await axios.post(fullUrl, {
      url: url,
      token: token,
      SPOrgName: SPOrgName,
      PCName: PCName,
    });

    const returnedData = response.data;
    const stateObject = returnedData.state_object;
    const user = true;
    const tenantId = returnedData.variables.tenantId;
    const planningCycleId = returnedData.variables.planningCycleId;
    const deploymentModelId = returnedData.variables.deploymentModelId;
    const tenantGlobalId = returnedData.variables.tenantGlobalId;
    const dataModelId = returnedData.variables.dataModelId;

    const userParams = {
      user,
      stateObject,
      tenantId,
      planningCycleId,
      deploymentModelId,
      tenantGlobalId,
      dataModelId,
    };
    return userParams;
  } catch (error) {
    console.error(error);
    const loginFailUserParams = {
      user: null,
      stateObject: error?.response?.data?.detail?.state_object || null,
      tenantId: null,
      planningCycleId: null,
      deploymentModelId: null,
      tenantGlobalId: null,
    };
    return loginFailUserParams;
  }
};
